import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PublicScanStatusResponse } from '@brand24-original/llm-types';
import './ScanProgress.scss';

interface ScanProgressProps {
  status?: PublicScanStatusResponse;
}

/** Etapy w kolejności, w jakiej przechodzi je skan — kolejny podświetla się, gdy backend go zgłosi. */
const STEPS: Array<{ key: string; statuses: string[] }> = [
  { key: 'scanStepQuestions', statuses: ['PENDING_CONFIRM', 'CONFIRMED', 'CREATING'] },
  { key: 'scanStepAsking', statuses: ['COLLECTING'] },
  { key: 'scanStepBuilding', statuses: ['BUILDING', 'READY'] },
];

const ScanProgress: React.FC<ScanProgressProps> = ({ status }) => {
  const { t } = useTranslation();
  const currentStep = Math.max(
    0,
    STEPS.findIndex((step) => step.statuses.includes(status?.status ?? 'CONFIRMED'))
  );

  const promptsProgress =
    status?.promptsTotal && status.promptsTotal > 0
      ? `${status.promptsReady}/${status.promptsTotal}`
      : null;

  return (
    <div className="scan-progress">
      <div className="logo">
        <div className="logo-box" />
      </div>
      <h1>{t('scanProgressTitle')}</h1>
      <p className="scan-progress__desc">
        {status?.domain ? t('scanProgressDesc', { domain: status.domain }) : t('scanProgressDescGeneric')}
      </p>

      <ul className="scan-progress__steps">
        {STEPS.map((step, index) => (
          <li
            key={step.key}
            className={`scan-progress__step${
              index < currentStep ? ' scan-progress__step--done' : ''
            }${index === currentStep ? ' scan-progress__step--active' : ''}`}
          >
            <span className="scan-progress__step-marker" />
            <span className="scan-progress__step-label">{t(step.key)}</span>
            {index === 1 && promptsProgress && (
              <span className="scan-progress__step-counter">{promptsProgress}</span>
            )}
          </li>
        ))}
      </ul>

      <p className="scan-progress__note">{t('scanProgressNote')}</p>
    </div>
  );
};

export default ScanProgress;
